import * as _ from 'lodash-es';

/**
 * @description 選択ファイルのタイプをチェック
 * @param {*} file 選択ファイル
 */
export const approvalFileType = async (
  file: File,
  approvalTypeList: string[]
) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      if (e.target?.result instanceof ArrayBuffer) {
        const arr = new Uint8Array(e.target.result).subarray(0, 4);
        let header = '';
        for (let i = 0; i < arr.length; i++) {
          header += arr[i].toString(16);
        }
        _.forEach(approvalTypeList, (type) => {
          if (header.startsWith(type)) {
            resolve(true);
          }
        });
      }
      reject(false);
    };
    reader.onerror = function () {
      reject(false);
    };
    reader.readAsArrayBuffer(file);
  });
};
